import { motion } from "framer-motion";
import { Play } from "lucide-react";
import { RevealLines, FadeUp } from "@/components/Reveal";

const WATCH_URL = "https://crunchyroll.com/watch/G4VUQ2EJD/the-bride-prince%3Futm_medium%3Dios%26utm_source%3DCopy-Link";

export const AnimeFeature = () => (
  <section id="anime" className="relative py-24 md:py-36" data-testid="anime-section">
    <div className="max-w-[1400px] mx-auto px-5 md:px-10 grid lg:grid-cols-12 gap-10 lg:gap-14 items-center">
      <motion.a href={WATCH_URL} target="_blank" rel="noopener noreferrer" data-testid="anime-watch-image-link"
        initial={{ opacity: 0, y: 40 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, amount: 0.1 }}
        transition={{ duration: 1, ease: [0.22, 1, 0.36, 1] }}
        className="lg:col-span-6 group relative block aspect-[4/5] sm:aspect-[16/11] overflow-hidden rounded-[28px] border border-purple-300/20">
        <img src="/img/hero-art.webp" alt="Two figures among blossoms under the moon"
          className="absolute inset-0 w-full h-full object-cover transition-transform duration-[1.4s] group-hover:scale-105" />
        <div className="absolute inset-0 bg-gradient-to-t from-[#0e0616]/80 via-transparent to-transparent" />
        <span className="absolute inset-0 grid place-items-center">
          <span className="w-20 h-20 rounded-full bg-purple-100/90 text-[#0e0616] grid place-items-center transition-transform duration-500 group-hover:scale-110">
            <Play className="w-8 h-8 ml-1" fill="currentColor" />
          </span>
        </span>
        <span className="absolute bottom-5 left-5 font-mono text-[11px] uppercase tracking-[0.28em] text-purple-50">Episode · The Bride Prince</span>
      </motion.a>
      <div className="lg:col-span-6">
        <p className="font-mono text-[11px] uppercase tracking-[0.28em] text-purple-200 mb-6">Watch with us</p>
        <h2 className="font-display text-5xl md:text-7xl leading-[0.92] tracking-tight" data-testid="anime-title">
          <RevealLines inView lines={[<>Heaven Official's</>, <em className="text-amber-200">Blessing.</em>]} />
        </h2>
        <FadeUp className="mt-6 max-w-md text-purple-50/90 leading-relaxed">
          A story Liza wants everyone to see: a fallen god, a devoted ghost king, and eight hundred years of waiting.
        </FadeUp>
        <FadeUp delay={0.1}>
          <a href={WATCH_URL} target="_blank" rel="noopener noreferrer" data-testid="anime-watch-btn"
            className="mt-10 inline-flex items-center gap-3 rounded-full bg-purple-200 text-[#0e0616] pl-7 pr-2 py-2 font-medium hover:bg-amber-200 transition-colors duration-500">
            Watch on Crunchyroll
            <span className="w-10 h-10 rounded-full bg-[#0e0616] text-purple-100 grid place-items-center"><Play className="w-4 h-4" /></span>
          </a>
        </FadeUp>
      </div>
    </div>
  </section>
);
